import { seaOptionCopy, siteCopy } from "../../content";
import type { HotspotId, SeaState } from "../../app/experience-state";
import styles from "./SeaCheckInPanel.module.css";

type SeaCheckInPanelProps = {
  value?: SeaState;
  onChange: (value: SeaState) => void;
  onContinue: (hotspot: HotspotId) => void;
};

const copy = siteCopy.sea;

/** Where each answer leads is behaviour, not copy, so it stays here. */
const seaRoutes: Readonly<Record<SeaState, HotspotId>> = {
  calm: "menu",
  swell: "journal",
  storm: "hearth",
};

const seaOptions = (["calm", "swell", "storm"] as const).map((value) => ({
  value,
  symbol: { calm: "≈", swell: "∿", storm: "≋" }[value],
  next: seaRoutes[value],
  ...seaOptionCopy[value],
}));

export function SeaCheckInPanel({
  value,
  onChange,
  onContinue,
}: SeaCheckInPanelProps) {
  const selection = seaOptions.find((option) => option.value === value);

  return (
    <div className={styles.panel}>
      <fieldset className={styles.options}>
        <legend className={styles.srOnly}>{copy.legend}</legend>
        {seaOptions.map((option) => (
          <label
            className={`${styles.option} ${value === option.value ? styles.selected : ""}`}
            key={option.value}
          >
            <input
              type="radio"
              name="sea-state"
              value={option.value}
              checked={value === option.value}
              onChange={() => onChange(option.value)}
            />
            <span className={styles.symbol} aria-hidden="true">
              {option.symbol}
            </span>
            <span>{option.label}</span>
          </label>
        ))}
      </fieldset>

      <div className={styles.response} aria-live="polite">
        {selection ? (
          <>
            <p>{selection.response}</p>
            <button
              className={styles.continueButton}
              type="button"
              onClick={() => onContinue(selection.next)}
            >
              {selection.nextLabel}
              <span aria-hidden="true"> →</span>
            </button>
          </>
        ) : (
          <p>{copy.emptyResponse}</p>
        )}
      </div>
    </div>
  );
}
